module.exports = __webpack_public_path__ + "static/media/cap3-02-mob.72d29a62.jpg";